require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/fn/object/keys.js
// module id = 1675
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21